module.exports = __webpack_public_path__ + "img/inox-guide.584b6f8a.svg";